module.exports = __webpack_public_path__ + "static/media/arrow-back.8623bf3c.svg";